<p-toolbar class="fixed z-20 box-shadow w-full" styleClass="m-0 p-0 border-0 rounded-none">
  <div class="hidden md:flex items-center ml-6">
    <button type="button" pButton (click)="handleToogle($event)" aria-label="Menú"
      class="flex items-center gap-x-1 bg-blue-primary border-transparent rounded py-2 px-3">
      <i class="pi pi-align-justify text-yellow-primary text-sm"></i>
      <span class="uppercase text-sm font-medium">Menú</span>
    </button>
  </div>
  <div class="flex items-center ml-2.5 md:ml-0">
    <a [routerLink]="'/'">
      <img [ngSrc]="logoNavbar" loading="eager" alt="Logo Rayo Colombia" width="116" height="53"
        class="cursor-pointer hidden xs:block" />
      <img [ngSrc]="logoNavbar" loading="eager" alt="Logo Rayo Colombia" width="110" height="50"
        class="cursor-pointer block xs:hidden" />
    </a>
  </div>
  <div class="flex items-center ml-6 lg:hidden">
    <button type="button" pButton (click)="menu.toggle($event)" aria-label="Menú de Sidebar"
      class="relative flex items-center gap-x-1 bg-white border border-blue-primary rounded py-2 px-3">
      <i class="pi pi-align-justify text-orange-primary text-sm"></i>
      <span class="uppercase text-sm font-medium text-blue-primary text-ne">Items</span>
    </button>
    <p-tieredMenu #menu [popup]="true" [model]="menuItems" styleClass="p-0 rounded-md style-tieredmenu"></p-tieredMenu>
  </div>
  <div class="hidden lg:flex lg:items-center">
    <ul class="flex">
      <li *ngFor="let item of items_navbar; let idx=index" (mouseleave)="hiddenItems($event, idx)">
        <span *ngIf="item.subitems" (mouseover)="showItems($event, idx)"
          class="px-3 py-4 cursor-pointer text-sm text-stone-600 flex items-center gap-1.5 transition duration-500">
          <span>{{ item.name }}</span>
          <i class="pi pi-chevron-down text-[0.55rem]"></i>
        </span>
        <a *ngIf="!item.subitems" routerLink="/{{item.path}}" (mouseover)="hiddenItems($event, idx)"
          class="relative px-3 py-4 text-sm text-stone-600 flex items-center gap-1.5">
          <span>{{ item.name }}</span>
        </a>
        <ul *ngIf="item.subitems && show && idx === index" (mouseleave)="hiddenItems($event, idx)"
          class="absolute w-52 bg-white px-4 py-2 pt-4 z-10 -mt-2 border-t-2 border-amber-500 transition-all duration-500 shadow-md">
          <li *ngFor="let item of item.subitems">
            <a *ngIf="item.name === 'Misión' || item.name === 'Visión'" routerLink="/{{item.path}}"
              class="relative py-2.5 px-3 text-sm text-stone-600 flex items-center gap-1.5 transition duration-500 hover:text-amber-500 hover:bg-neutral-100"
              (click)="hiddenItems($event, idx)" fragment="mision-vision">
              <span>{{ item.name }}</span>
            </a>
            <a *ngIf="!(item.name === 'Misión' || item.name === 'Visión')" routerLink="/{{item.path}}"
              class="relative py-2.5 px-3 text-sm text-stone-600 flex items-center gap-1.5 transition duration-500 hover:text-amber-500 hover:bg-neutral-100"
              (click)="hiddenItems($event, idx)">
              <span>{{ item.name }}</span>
            </a>
          </li>
        </ul>
      </li>
    </ul>
    <button type="button" (click)="goToPagar()" aria-label="Menú Pagar"
      class="flex items-center flex-nowrap text-sm gap-1.5 bg-orange-primary text-white uppercase font-medium py-5 px-3 hover:bg-blue-primary hover:transition-all hover:duration-300 cursor-pointer">
      <span>Pagar</span>
      <i class="pi pi-dollar text-[0.75rem]"></i>
    </button>
    <a [routerLink]="journeyRoutes.SIMULADOR"
      class="flex items-center flex-nowrap text-sm gap-1.5 bg-yellow-primary text-white uppercase font-medium py-5 px-3 hover:bg-blue-secondary hover:transition-all hover:duration-300 cursor-pointer">
      <span>¡Pide tu cupo ya!</span>
      <i class="pi pi-arrow-right text-[0.55rem]"></i>
    </a>
  </div>
  <div *ngIf="!auth.login" class="flex items-center">
    <a class="flex items-center text-sm gap-2 bg-blue-primary text-white uppercase font-medium py-5 px-4 hover:bg-yellow-primary hover:transition-all hover:duration-300 cursor-pointer"
      [routerLink]="'/auth/login'">
      <span>Sesión</span>
      <i class="pi pi-user icon-sm"></i>
    </a>
  </div>
  <div *ngIf="auth.login" class="flex items-center">
    <a class="flex items-center gap-2 bg-blue-primary text-white uppercase font-medium py-[22px] px-[22px] xl:py-[18px] xl:px-4 hover:bg-orange-primary hover:transition-all hover:duration-300 cursor-pointer"
      [routerLink]="'/portal/dashboard'">
      <span class="hidden xl:block">Ir al Portal</span>
      <i class="pi pi-th-large icon-sm"></i>
    </a>
  </div>
</p-toolbar>

<app-payment-portal-modal [show]="showPaymentModal" (hidden)="hidePaymentModal()"></app-payment-portal-modal>
